import type { SVGProps } from 'react';

export function NotFound404({ className = '', ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <text
        x="50%"
        y="55%"
        textAnchor="middle"
        fontFamily="Fraunces, serif"
        fontSize="220"
        fontWeight="900"
        fill="currentColor"
        stroke="none"
      >
        404
      </text>
      <line x1="60" y1="300" x2="340" y2="300" stroke="#E7FF4D" strokeWidth="3" />
      <text
        x="50%"
        y="350"
        textAnchor="middle"
        fontFamily="Geist Mono, monospace"
        fontSize="14"
        fill="#E7FF4D"
        stroke="none"
        letterSpacing="4"
      >
        PAGE NOT FOUND
      </text>
    </svg>
  );
}
